module.exports = __webpack_public_path__ + "static/frida-hero-small-c052e8af1e658073db2598c3b60661ac.jpg";